<button
  type="button"
  class="app-page-actions-menu__trigger"
  mat-flat-button
  [matMenuTriggerFor]="menu"
>
  <i class="fa-solid fa-list"></i>
  {{ label }}
  <i class="fa-solid fa-caret-down"></i>
</button>

<mat-menu #menu="matMenu">
  <button
    *ngFor="let action of actions"
    mat-menu-item
    [disabled]="action.disabled"
    (click)="actionClick.emit(action.action)"
  >
    {{ action.label }}
  </button>
</mat-menu>
